import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import {
  UpdateVideoCategoryInput,
  VideoCategoryProps,
} from "../store/actionType";
import { CreateCategoryForm } from "modules/video/components/CreateFolderForm";
import {
  CategoryInput,
  CategoryError,
} from "modules/video/components/DataType";
import { ApiError } from "components";
import { updateVideoCategory } from "../store/action";

interface EditCategoryProps {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
  categoryData: VideoCategoryProps;
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & EditCategoryProps;

const EditCategory: React.FC<Props> = ({
  closeModal,
  categoryData,
  onUpdateVideoCategory,
}) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState<CategoryInput>({
    name: categoryData.name || "",
    description: categoryData.description || "",
    category_order: categoryData.category_order || 0
  });
  const [error, setError] = useState<CategoryError>({});
  const [apiError, setApiError] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const categoriesState = useSelector(
    (state: any) => state.videoCategories.videoCategoriesState
  );

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    var input: UpdateVideoCategoryInput = {
      name: formData.name,
      description: formData.description,
      category_order: formData.category_order,
      group_id: categoryData.group_id,
      folder_id: categoryData.folder_id,
      category_id: categoryData.id,
    };
    if (formData.name.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,
        name: "Category Name is required",
      }));
    }
    if (formData.description.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,
        description: "Category Description is required",
      }));
    }
    if (formData.category_order === 0) {
      setError((prevErrors) => ({
        ...prevErrors,
        category_order: "Category category order is required",
      }));
    }
    if (formData.name.trim() !== "" && formData.description.trim() !== "") {
      setLoading(true);
      onUpdateVideoCategory(input);
       setSubmitted(true);
      setLoading(false);
    }
  };
  useEffect(() => {
      if (!categoriesState.isLoading && submitted) {
        if (categoriesState.error) {
          setApiError(categoriesState.error); // show error
        } else {
          setApiError(null);
          closeModal(false);
        }
      }
    }, [categoriesState.isLoading, categoriesState.error, submitted, closeModal]);
  return (
    <>
      <CreateCategoryForm
        loading={loading}
        formData={formData}
        errors={error}
        handleChange={handleChange}
        handleSubmit={handleSave}
        header={"Edit Category"}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onUpdateVideoCategory: (input: UpdateVideoCategoryInput) =>
    dispatch(updateVideoCategory(input)),
});

export default connect(null, mapDispatchToProps)(EditCategory);
